<template>
  <div
    class="apartment-search-form-minimal"
    :class="classSize"
  >
    <div class="apartment-search-form-minimal__grid">

      <!-- Main -->
      <form
        class="apartment-search-form-minimal__main"
        @submit.prevent="submit"
        id="apartment-search-form-minimal"
      >
        <div class="apartment-search-form-minimal__main-top">
          <div class="apartment-search-form-minimal__main-top-column-main">
            <!-- Location -->

            <div class="apartment-search-form-minimal__modes-of-habitation">
                  <InputCheckbox
                    v-for="mode in modesOfHabitation"
                    v-bind:key="mode.value"
                    :value="mode.value"
                    :checked="form.type.includes(mode.value) ||
                      preset ? (preset.type.includes(mode.value) ? 'checked' : false) : 'checked'"
                    @change="toggleSearchType(mode.value)"
                  >
                    {{ translate(mode.title) }}
                  </InputCheckbox>
              </div>

            <div class="apartment-search-form-minimal__location">

              <InputWrap
                :wrap-label="false"
                v-slot="{id, error}"
                class="location-field-wrapper"
              >
                <MapPinIcon />
                <InputSelect
                  :id="id"
                  :options="locationOptions"
                  :internal-search="false"
                  :placeholder="translate('Paikkakunta, kaupunginosa, katu tai postinumero')"
                  :close-on-select="false"
                  track-by="value"
                  label="name"
                  data-cy="select-city"
                  @search-change="onLocationSearchTextChange"
                  @select="form.locations.push({...$event})"
                  hide-caret
                  :hide-dropdown="locationSearchText === null || locationSearchText.length < 2"
                  :error="error"
                  open-direction="bottom"
                >
                <template #beforeList>
                    <div
                      v-if="locationOptionsLoading"
                      class="apartment-search-form-minimal__location-dropdown-loading"
                    >
                      <LoadSpinner :margin="false"/>
                    </div>
                    <div
                      class="apartment-search-form-minimal__location-dropdown-empty"
                      v-else-if="locationOptions.length === 0"
                    >
                      {{translate('Haulla ei löytynyt tuloksia.')}}
                    </div>
                  </template>
                </InputSelect>
              </InputWrap>

              <button
                  type="submit"
                  class="btn btn--large location-search-button"
                  id="apartment-search-form-button-minimal"
                >
                {{translate('Hae asuntoja')}}
                <SearchIcon />
              </button>

            </div>

            <div
                v-if="form.locations.length > 0"
                class="apartment-search-form-minimal__location-tags"
              >
                <TagList
                  data-cy="city-tag-list"
                  :items="form.locations.map((location) => ({title: location.name, active: true}))"
                  @item-click="form.locations.splice($event, 1)"
                />
            </div>


            <input
              v-if="show_campaign"
              type="hidden"
              id="apartment-search-form-show-campaign"
              value="1"
            />

          </div>
        </div>


      </form>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';
  import {debounce} from 'debounce';
  import {validationMixin} from 'vuelidate';
  import {required} from 'vuelidate/lib/validators'

  import globals from '../../lib/globals';
  import utils from '../mixins/utils';
  import InputWrap from './InputWrap';
  import InputText from './InputText';
  import TagList from './TagList';
  import InputCheckbox from './InputCheckbox';
  import InputSelect from './InputSelect';
  import LoadSpinner from './LoadSpinner';

  // Icons.
  import MapPinIcon from '../icons/MapPinIcon.vue';
  import SearchIcon from '../icons/SearchIcon2.vue';

  export default {
    components: {
      LoadSpinner,
      InputCheckbox,
      TagList,
      InputWrap,
      InputText,
      InputSelect,
      MapPinIcon,
      SearchIcon
    },
    emits: [
      'submitAllTypes'
    ],
    mixins: [
      utils.translate,
      validationMixin,
    ],
    props: {
      preset: {
        type: Object,
        default: null,
      },
      size: {
        type: String,
        default: 'full',
      },
      show_campaign: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      const preset = this.preset ? this.preset : {};
      const show_campaign = this.show_campaign ? this.show_campaign : false;
      const form = {
        type: 'right-of-occupancy',
        locations: [],
        booleanFilters: [],
        show_campaign: show_campaign,
        ...preset,
      };

      return {
        locationSearchText: null,
        locationOptionsLoading: false,
        locationOptions: [],
        //hasAnyCampaigns: {},
        modesOfHabitation: [
          {
            title: 'Omistusasunnot',
            value: 'owner-occupancy',
          },
          {
            title: 'ASO-asunnot',
            value: 'right-of-occupancy',
          },
          {
            title: 'Vuokra-asunnot',
            value: 'rental',
          },
        ],
        form,
      };
    },
    mounted() {
      //this.hasAnyCampaignsRequest();
      //this.checkApartments();
      //this.getBuildingTypes();

      if (this.show_campaign) {
        this.toggleBooleanFilter('campaign');
      }
    },
    computed: {
      classSize() {
        return {
          'apartment-search-form--card-wide': this.size === 'card-wide',
          'apartment-search-form--full': this.size === 'full',
        };
      },
    },
    methods: {
      onLocationSearchTextChange(searchText) {
        this.locationOptions = [];
        this.locationSearchText = searchText;

        if (searchText.length < 2) {
          return;
        }

        this.locationOptionsLoading = true;
        this.requestLocationsLazy(searchText);
      },
      requestLocationsLazy: debounce(async function (searchText) {
        let searchType = this.form.type;
        const url = `${globals.urlIntegrationApi}/public/location-filters-all-types-search?s=${encodeURIComponent(searchText)}&t=${searchType}`;
        const response = await axios.get(url);

        // Bail out if the search text has been changed since
        if (this.locationSearchText !== searchText) {
          return;
        }

        this.locationOptionsLoading = false;
        this.locationOptions = response.data
          .filter((item) => !this.form.locations.map(i => i.value).includes(item.value))

      }, 500),
      toggleSearchType(type) {
        const typeIndex = this.form.type.findIndex(t => t === type);
        if (typeIndex === -1) {
          this.form.type.push(type);
        } else {
          this.form.type.splice(typeIndex, 1);
        }
      },
      toggleBooleanFilter(filter) {
        const filterIndex = this.form.booleanFilters.findIndex(f => f === filter);
        if (filterIndex === -1) {
          this.form.booleanFilters.push(filter);
        } else {
          this.form.booleanFilters.splice(filterIndex, 1);
        }
      },
      submit() {
        const formCopy = JSON.parse(JSON.stringify(this.form));

        const stateString = encodeURIComponent(JSON.stringify(formCopy));
        this.$emit('submit-all-types-minimal', formCopy, stateString);
        window.history.pushState('', '', `?q=${stateString}`);
      },
    },
  }
</script>

<style lang="scss">
  @import "~styles/definitions";

  @mixin apartment-search-form-minimal__medium {
    .apartment-search-form-minimal--card-wide & {
      @include media-breakpoint-up(xl) {
        @content;
      }
    }

    .apartment-search-formi-minimal--full & {
      @include media-breakpoint-up(md) {
        @content;
      }
    }
  }

  @mixin apartment-search-form-minimal__large {
    .apartment-search-form-minimal--full & {
      @include media-breakpoint-up(xl) {
        @content;
      }
    }
  }

  @mixin apartment-search-form-minimal__main-top-column() {
    // margin-bottom: r(16);

    @include apartment-search-form-minimal__large {
      margin: 0 r(24);
    }
  }

  .apartment-search-form-minimal {
    background-color: transparent;
  }

  .apartment-search-form-minimal__grid {
    padding: r(40) r(12) 0 r(12);

    @include apartment-search-form-minimal__medium {
      display: flex;
      padding: 0 r(32);
    }

    @include apartment-search-form-minimal__large {
      padding: 0 r(80) 0 r(48);
    }
  }

  .apartment-search-form-minimal__sidebar {
    margin-bottom: r(24);

    @include apartment-search-form-minimal__medium {
      width: r(160);
      padding-top: r(32);
      padding-right: r(24);
      border-right: r(1) solid #d8d8d8;
      margin-right: r(16);
      margin-bottom: 0;
    }

    @include apartment-search-form-minimal__large {
      width: r(280);
      padding-right: r(48);
      padding-top: r(40);
      margin-right: r(40);
    }
  }

  .apartment-search-form-minimal__title {
    @include font-h-28;
    margin-bottom: r(24);
    text-align: center;

    @include apartment-search-form-minimal__medium {
      margin-bottom: r(40);
      text-align: left;
    }

    @include apartment-search-form-minimal__large {
      @include font-h-42;
    }
  }

  .apartment-search-form-minimal__instructions {
    display: none;

    @include apartment-search-form-minimal__medium {
      display: block;
    }
  }

  .apartment-search-form-minimal__instructions-unit {
    @include font-label-16;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;

    @include apartment-search-form-minimal__large {
      flex-direction: row;
      text-align: left;
    }

    & + & {
      margin-top: r(22);
    }
  }

  .apartment-search-form-minimal__instructions-text {
    width: 100%; // ie
  }

  .apartment-search-form-minimal__instructions-icon {
    margin-bottom: r(8);

    @include apartment-search-form-minimal__large {
      margin-right: r(16);
      margin-bottom: 0;
    }

    svg {
      width: r(32);
      height: r(32);

      @include apartment-search-form-minimal__large {
        width: r(52);
        height: r(52);
      }
    }
  }

  .apartment-search-form-minimal__main {
    flex: 1;

    @include apartment-search-form-minimal__medium {
      padding: r(32) 0;
    }

    @include apartment-search-form-minimal__large {
      padding: r(40) 0;
    }
  }

  .apartment-search-form-minimal__main-tabs {
    @include reset-list;
    display: flex;
    justify-content: center;
    margin-bottom: r(24);

    @include apartment-search-form-minimal__medium {
      justify-content: flex-start;
      margin-bottom: r(40);
    }
  }

  .apartment-search-form-minimal__tab {
    & + & {
      margin-left: r(16);

      @include apartment-search-form-minimal__large {
        margin-left: r(28);
      }
    }
  }

  .apartment-search-form-minimal__tab-button {
    @include reset-button(true);
    @include font-h-16;
    position: relative;
    transition: padding-left 0.2s;
    color: rgba($color-black, 0.5);

    @include apartment-search-form-minimal__medium {
      @include font-h-18;
    }

    @include apartment-search-form-minimal__large {
      @include font-h-22;
    }

    &--active {
      color: $color-pink;

      &:after {
        content: "";
        position: absolute;
        left: 0;
        right: 0;
        bottom: r(-4);
        background-color: $color-pink;
        height: r(2);
      }
    }

    &--yellow.apartment-search-form-minimal__tab-button--active {
      color: $color-yellow;

      &:after {
        background-color: $color-yellow;
      }
    }

    &--blue.apartment-search-form-minimal__tab-button--active {
      color: $color-blue;

      &:after {
        background-color: $color-blue;
      }
    }
  }

  .apartment-search-form-minimal__main-top {
    @include apartment-search-form-minimal__medium {
      margin-bottom: r(48);
    }

    @include apartment-search-form-minimal__large {
      display: flex;
      justify-content: space-between;
      margin-left: r(-24);
      margin-right: r(-24);
    }
  }

  .apartment-search-form-minimal__main-top-column-main {
    @include apartment-search-form-minimal__main-top-column;
    display: flex;
    flex-direction: column;
    justify-content: center;

    @include media-breakpoint-down(md) {
      min-width: 32rem;
    }

    @include media-breakpoint-down(sm) {
      min-width: 21rem;
    }

    @include apartment-search-form-minimal__large {
      flex: 4 1;
      min-width: r(320);
      max-width: r(380);
    }
  }

  .location-search-button {
      display: flex;
      padding: 1rem 2rem;
      border-radius: 0 2rem 2rem 0;
      background-color: $color-pink-2025;
      color: $color-green-2025;
      width: max-content;
      white-space: nowrap;
      flex-wrap: nowrap;
      align-items: center;

      @include media-breakpoint-down(md) {
        border-radius: 2rem;
        width: 100%;
      }

      .search {
        width: 1em;
        height: 1em;
      }
    }

  .apartment-search-form-minimal__location {
    display: flex;
    align-items: center;
    margin-bottom: r(8);
    gap: 0.5rem;
    align-items: stretch;
    flex-wrap: wrap;

    @include media-breakpoint-down(md) {
      flex-direction: column;
      justify-content: center;
    }

    .location-field-wrapper {
      flex-grow: 1;
      display: inline-block;

      > div:not([class]) {
        position: relative;
      }

      .map-pin {
        position: absolute;
        top: 50%;
        left: .75rem;
        color: $color-black;
        z-index: 100;
        transform: translateY(-50%);
      }
    }

    .multiselect__tags {
      border: none;
      padding: r(18) r(16) r(18) r(44);
      border-radius: 3em 0 0 3em;
      height: 3.5em;

      @include media-breakpoint-down(md) {
        border-radius: 3em;
      }
    }
    .multiselect__content-wrapper {
      margin-left: 2rem;
      margin-right: 2rem;
      border: none;
    }
    .multiselect__placeholder {
      font-size: r(16);
      font-style: normal;
      font-family: $ff-lato !important;
    }

    @include apartment-search-form-minimal__large {
      margin-bottom: r(40);
    }
  }

  .apartment-search-form-minimal__location-dropdown-loading {
    padding: r(12) 0;
    color: $color-pink-2025;

  }

  .apartment-search-form-minimal__location-dropdown-empty {
    padding: r(8) r(16);
  }

  .apartment-search-form-minimal__location-tags {
    // margin-top: r(10);
  }

  .apartment-search-form-minimal__double-field {
    display: flex;
    margin: 0 r(-10);
  }

   .apartment-search-form-minimal__double-field--blue--first {
    margin: 0 r(-10) r(16);
  }

  .apartment-search-form-minimal__double-field-column {
    width: 50%;
    padding: 0 r(10);
  }

  .apartment-search-form-minimal__total-price {
    margin-top: r(10);
  }

  .apartment-search-form-minimal__main-top-column-side {
    @include apartment-search-form-minimal__main-top-column;

    @include apartment-search-form-minimal__large {
      flex-grow: 1;
      max-width: r(264);
    }
  }

  .apartment-search-form-minimal__grid-checkboxes {
    @include apartment-search-form-minimal__large {
      display: flex;
      justify-content: space-between;
      margin-left: r(-16);
      margin-right: r(-16);
    }
  }

  .apartment-search-form-minimal__grid-checkboxes-column {
    margin-bottom: r(16);

    @include apartment-search-form-minimal__large {
      margin: 0 r(16);
    }
  }

  .apartment-search-form-minimal__checkboxes {
    display: flex;
    flex-wrap: wrap;
    margin: r(-4) r(-6);

    @include apartment-search-form-minimal__medium {
      margin: r(-7) r(-10);
    }

    @include apartment-search-form-minimal__large {
      padding-top: r(4);
      flex-direction: column;
      margin: 0 0 r(-8);
    }
  }

  .apartment-search-form-minimal__checkbox {
    margin: r(4) r(6);

    @include apartment-search-form-minimal__medium {
      margin: r(7) r(10);
    }

    @include apartment-search-form-minimal__large {
      margin: r(8) 0;
    }
  }

  .apartment-search-form-minimal__showing-checkbox {
    margin-top: r(16);
    border-top: r(1) solid #d8d8d8;
    padding-top: r(16);
  }
  .apartment-search-form-minimal__own-plot-checkbox {
    margin-top: r(16);
  }

  .apartment-search-form-minimal__campaign-checkbox {
    margin-top: r(16);
    font-weight: bold;
  }

  .apartment-search-form-minimal__campaign-checkbox {
    margin-top: r(16);
    font-weight: bold;
  }

  .apartment-search-form-minimal__main-middle {
    margin-bottom: r(16);

    @include apartment-search-form-minimal__medium {
      margin-bottom: r(4);
    }
  }

  .apartment-search-form-minimal__toggle-more-container {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;

    @include apartment-search-form-minimal__medium {
      justify-content: flex-start;
    }

    &::before {
      content: "";
      position: absolute;
      left: 0;
      right: 0;
      height: r(1);
      background-color: #d8d8d8;
    }
  }

  .apartment-search-form-minimal__toggle-more {
    @include reset-button(true);
    @include font-label-12;
    position: relative;
    display: flex;
    align-items: center;
    line-height: calc(15 / 12);
    padding: 0 r(8);
    background-color: $color-white;

    &:focus {
      text-decoration: underline;
    }

    @include apartment-search-form-minimal__large {
      @include font-label-14;
    }
  }

  .apartment-search-form-minimal__toggle-more-icon {
    @include square(r(28));
    flex-shrink: 0;
    overflow: hidden;
    margin-right: r(14);
    border-radius: r(14);
    background-color: $color-pink;
    color: $color-white;

    &--yellow {
      background-color: $color-yellow;
    }

    &--blue {
      background-color: $color-blue;
    }

    svg {
      @include square(r(40));
      margin: r(-6);
    }
  }

  .apartment-search-form-minimal__hidden-fields {
    margin-top: r(32);

    @include apartment-search-form-minimal__medium {
      margin-bottom: r(64);
    }
  }

  .apartment-search-form-minimal__boolean-filters {
    margin-top: r(16);
  }

  .apartment-search-form-minimal__bottom-filters-title {
    @include font-label-16;
    margin: r(40) 0 r(24);
  }

  .apartment-search-form-minimal__bottom-filters {
    margin: r(16) r(-8) r(-16);

    @include apartment-search-form-minimal__large {
      display: flex;
    }
  }

  .apartment-search-form-minimal__bottom-filter-col {
    padding: 0 r(8) r(16);

    @include apartment-search-form-minimal__large {
      width: 50%;
    }
  }

  .apartment-search-form-minimal__joined-fields {
    display: flex;
    margin: 0 r(-4);
  }

  .apartment-search-form-minimal__joined-field {
    width: 50%;
    margin: 0 r(4);
  }

  .apartment-search-form-minimal__main-bottom {
    display: flex;
    justify-content: center;

    @include apartment-search-form-minimal__medium {
      justify-content: flex-end;
    }
  }
  .apartment-search-form-minimal__modes-of-habitation {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
    margin-bottom: r(24);
    text-align: center;
    justify-content: center;

    @include media-breakpoint-down(md) {
      flex-direction: column;
    }

    .input-wrapper {
      display: flex;

      @include media-breakpoint-down(md) {
        justify-content: center;
      }
    }

    /* Custom checkbox */
    input[type="checkbox"] {
      position: absolute;
      top: auto;
      overflow: hidden;
      clip: rect(1px, 1px, 1px, 1px);
      width: 1px;
      height: 1px;
      white-space: nowrap;
    }

    input[type=checkbox] + label {
      display: block;
      padding: .333em;
      padding-left: .6em;
      max-width: calc(100% - 2em);
      position: relative;
      white-space: nowrap;
      line-height: 2em;
      font-weight: 700;
      font-size: r(24);
      line-height: 1em;
      width: initial;
    }

    input[type="checkbox"] + label::before {
      content: '';
      border: .1em solid currentColor;
      background-color: transparent;
      border-radius: 3em;
      display: block;
      box-sizing: border-box;
      // float: left;
      width: 0.833em;
      height: 0.833em;
      vertical-align: middle;
      cursor: pointer;
      text-align: center;
      transition: all .1s ease-out;
      position: absolute;
      left: calc( -1.667em + .5em - .1em );
      top: 0.4167em;
    }

    input[type="checkbox"] + label::after {
      content: '';
      display: block;
      position: absolute;
      top: .5em;

      width: 1em;
      height: 1em;
      transform: rotate(0deg);
      transition: all .1s ease-out;
    }

    input[type="checkbox"]:checked + label::before {
      width: 1.667em;
      height: 1.667em;
      background-color: $color-pink-2025;
      border: 0;
      position: absolute;
      left: -1.667em;
      top: 0;
    }

    input[type="checkbox"]:checked + label::after {
      top: 0.1em;
      left: -1.2em;
      width: 0.6em;
      height: 1.2em;
      border-right: .1em solid $color-green-2025;
      border-bottom: .1em solid $color-green-2025;
      transform: rotate(45deg);
    }

  }
</style>
